import styled from 'styled-components'

export default styled.hr`
  color: ${({ theme }) => theme.colors.borderLight};
  border: 0.5px solid ${({ theme }) => theme.colors.borderLight};
  margin: 17px 0;
`
